import type { Placement } from '@floating-ui/react'
import classNames from 'classnames'
import { ReactElement, useState } from 'react'
import { Tooltip } from 'app/components/Tooltip'

/**
 * Component to render a text element with a tooltip that displays the full text if the text is too long.
 * @param className CSS classes to apply to the span element.
 * @param content The content to display in the span element.
 * @param hasTooltip Decide if the tooltip should be displayed.
 * @param placement Where the tooltip opens relative to the text.
 * @returns A span element with a tooltip that renders if the space is not long enough.
 */
export function OverflowText({
  className,
  content,
  hasTooltip = false,
  placement = `top`,
}: {
  className?: string
  content?: string
  hasTooltip?: boolean
  placement?: Placement
}): ReactElement {
  const [tooltipContent, setTooltipContent] = useState<string | undefined>()
  return content ? (
    <Tooltip
      message={hasTooltip ? tooltipContent : ``}
      placement={placement}
      className={classNames(className, `truncate`)}
      onMouseOver={(evt) => {
        if (evt.currentTarget instanceof HTMLElement && evt.currentTarget.scrollWidth > evt.currentTarget.clientWidth) {
          setTooltipContent(content)
        } else setTooltipContent(undefined)
      }}
    >
      {content}
    </Tooltip>
  ) : (
    <></>
  )
}
